import { Divider } from "@msuite/ui/divider";
import { PlanStateTag } from "@msuite/ui/tag";
import { TimelineItem } from "@msuite/ui/timeline";
import type { UserTimelineAssignmentItem as UserTimelineAssignmentItemType } from "@msuite/utils/types";
import { OrganizationCard, TicketTypeIcon } from "@/components/cards";

/** Props Interface */
interface UserTimelineAssignmentItemProps {
	item: UserTimelineAssignmentItemType;
}

export function UserTimelineAssignmentItem({ item }: UserTimelineAssignmentItemProps) {
	return (
		<div className="v-stack">
			<TimelineItem state={item._crew._plan.state}>
				<div className="flex flex-row justify-between col-span-2">
					<OrganizationCard
						orgId={item._crew.orgId}
						suffix={item._crew.ranking}
						variant="plain"
						fontWeight="semibold"
					/>
					<PlanStateTag state={item._crew._plan.state} />
				</div>
				<Divider
					className="col-span-2 mt-2"
					variant="card"
				/>
				<div className="v-stack gap-0 col-span-2 -mx-3">
					{item._crew._ticketAssignments.map((ticketAssignment) => (
						<div
							className="py-1.5 not-last:border-b-[0.5px] border-color px-3"
							key={ticketAssignment.id}
						>
							<div className="h-stack">
								<TicketTypeIcon ticketTypeId={ticketAssignment._ticket.type} />
								<div className="max-w-[80%]">
									<p>{ticketAssignment._ticket.description}</p>
								</div>
								<div className="flex-1" />
								<div className="w-max whitespace-nowrap">
									<p className="label">{ticketAssignment._ticket.number}</p>
								</div>
							</div>
						</div>
					))}
				</div>
			</TimelineItem>
		</div>
	);
}
